import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toastClass = '--background: #0d0d0d';
  successMessage = '<ion-icon class="icon secondary" name="checkmark-circle"></ion-icon>';

  constructor(public toastController: ToastController) {
  }

  async display(message?: any, position?: any) {
    const toastType = 'app-toast';
    const toast = await this.toastController.create({
      message: message || 'Hello',
      // message: this.successMessage + '  ' + message || 'Hello',
      duration: 3000,
      cssClass: toastType,
      position: position || 'bottom',
      buttons: [
        {
          side: 'start',
          icon: 'checkmark-circle',
          cssClass: 'app-toast',
          handler: () => {
          }
        }
      ]
    });
    await toast.present();
  }

  async error(message?: any, position?: any) {
    const toast = await this.toastController.create({
      message: message || 'Hello',
      duration: 3000,
      cssClass: 'app-toast-error',
      position: position || 'bottom',
      buttons: [
        {
          side: 'start',
          icon: 'close-circle',
          cssClass: 'app-toast-error',
          handler: () => {
          }
        }
      ]
    });
    await toast.present();
  }
}
